enum SignalType {
  ROLE_CHANGE = 'RoleChange',
  COMPANY_CHANGE = 'CompanyChange',
  WEBSITE_VISIT = 'WebsiteVisit',
  UNKNOWN_COMPANY_VISIT = 'UnknownCompanyVisit',
  INTERESTED_CLICK = 'InterestedClick',
  INTERESTED_OPEN = 'InterestedOpen',
  HIRING_COMPANY = 'Hiring',
}

export default SignalType;
